import  { instance  } from "../api";
const fetchSecteur = (setSecteurAttributes) => {
  
      instance.get("/api/secteurs/")
      .then((result)=>  { 
        setSecteurAttributes(result.data)
       
      
     })                  
    .catch ((error) =>{console.log('error', error)
      
    })
};

export default fetchSecteur;